<template>
  <div>
    <div class="bg-[#104939] mx-[5px] p-[12px]">
      <div class="text-[15px] color-[#FFFFFF]">{{ $t('convidarCentro.agentNetwork.howToStartEarning') }}</div>
      <div class="flex items-center my-[9px] justify-between">
        <div class="flex flex-col items-center">
          <img :src="getAssetsFile('activity/referralProgram/ruleimg1.png')" alt="" class="w-[76px] h-[81px]">
          <div class="text-[11px] color-[#FFFFFF] mt-[9px] w-[100px] text-wrap text-center">{{
            $t('convidarCentro.agentNetwork.inviteFriendsBySharing') }}
          </div>
        </div>
        <img :src="getAssetsFile('activity/referralProgram/right.png')" alt="" class="w-[15px] h-[15px] ">
        <div class="flex flex-col items-center">
          <img :src="getAssetsFile('activity/referralProgram/ruleimg2.png')" alt="" class="w-[76px] h-[81px]">
          <div class="text-[11px] color-[#FFFFFF] mt-[9px] w-[100px] text-wrap text-center">{{
            $t('convidarCentro.agentNetwork.friendsJoinAndPlay') }}
          </div>
        </div>
        <img :src="getAssetsFile('activity/referralProgram/right.png')" alt="" class="w-[15px] h-[15px] ">
        <div class="flex flex-col items-center">
          <img :src="getAssetsFile('activity/referralProgram/ruleimg3.png')" alt="" class="w-[76px] h-[81px]">
          <div class="text-[11px] color-[#FFFFFF] mt-[9px] w-[100px] text-wrap text-center">{{
            $t('convidarCentro.agentNetwork.youEarnRewards') }}
          </div>
        </div>
      </div>
      <div style="height: 1px;background: #009F76;border-radius: 0px 0px 0px 1px;opacity: 0.35;margin-top: 15px;">
      </div>
      <div class="text-[15px] color-[#FFFFFF] mt-[18px]">{{ $t('convidarCentro.agentNetwork.howToEarnMore') }}</div>
      <div class="flex  justify-center items-center mt-[10px]">
        <img :src="getAssetsFile('activity/referralProgram/ruleimg4.png')" alt="" class="w-[40%] h-[40%]">
      </div>
      <div class="color-[#FFFFFF] text-[11px] mt-[30px]">
        <div>{{ $t('convidarCentro.agentNetwork.promoterUpgradeDescription') }}</div>
        <div class="my-[10px]">{{ $t('convidarCentro.agentNetwork.higherLevelMoreCommission') }}</div>
        <div class="flex  items-center mt-[15px]">
          <img :src="getAssetsFile('/home/weibao.png')" alt="" class="w-[44px] h-[37px]">
          <div class="ml-[7px]">
            {{ $t('convidarCentro.agentNetwork.treasureChestsAwait') }}
            <div class="color-[#009F76] text-[11px]">
              {{ $t('convidarCentro.agentNetwork.reachInviteTarget') }}
            </div>
          </div>
        </div>
      </div>
      <div style="height: 1px;background: #009F76;border-radius: 0px 0px 0px 1px;opacity: 0.35;margin-top: 15px;"></div>
      <div class="text-[15px] color-[#FFFFFF] mt-[18px]">{{ $t('convidarCentro.agentNetwork.howToEarnMore') }}</div>
      <div class="flex  justify-center items-center mt-[10px]">
        <img :src="getAssetsFile('activity/referralProgram/ruleimg6.png')" alt="" class="w-[40%] h-[40%]">
      </div>

      <!-- 推广员等级表格 -->
      <div class="mt-[15px]">
        <div class="promoter-table">
          <!-- 表头 -->
          <div class="table-header">
            <div class="th">{{ $t('convidarCentro.agentNetwork.promoter') }}</div>
            <div class="th" v-for="level in levels" :key="level">{{ $t('convidarCentro.agentNetwork.level') }}{{ level
            }}
            </div>
          </div>
          <!-- 邀请人数行 -->
          <div class="table-row">
            <div class="td">{{ $t('convidarCentro.agentNetwork.invited') }}</div>
            <div class="td" v-for="level in levels" :key="level">
              {{ getConditionValue(level, 3) }}
            </div>
          </div>
          <!-- 投注条件行 -->
          <div class="table-row">
            <div class="td">{{ $t('convidarCentro.agentNetwork.valid') }}</div>
            <div class="td" v-for="level in levels" :key="level">
              {{ getConditionValue(level, 5) }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="parsedDesc?.img || parsedDesc?.desc"
        style="height: 1px;background: #009F76;border-radius: 0px 0px 0px 1px;opacity: 0.35;margin-top: 15px;"></div>
      <div v-if="parsedDesc?.img || parsedDesc?.desc" class="text-[15px] color-[#FFFFFF] mt-[18px]">{{
        $t('convidarCentro.agentNetwork.howIsCommissionCalculated') }}
      </div>
      <div v-if="parsedDesc?.img || parsedDesc?.desc"
        class="flex items-center justify-center mt-[15px] w-full flex-col">
        <img v-if="parsedDesc?.img" :src="VITE_IMG_URL + parsedDesc.img" alt="" class="w-[98%]">
        <div v-if="parsedDesc?.desc" class="color-[#FFFFFF] text-[11px] mt-[10px]">{{ parsedDesc.desc }}</div>
      </div>

    </div>
  </div>


</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted, computed } from 'vue'
import { getPromoterConfig } from '@/api/game'
import { useI18n } from 'vue-i18n'
import { getAssetsFile } from '@/utils/pub-use'

const { t, locale } = useI18n() // 添加 locale

const VITE_IMG_URL = import.meta.env.VITE_IMG_URL
const promoterLevelInfo = ref<any[]>([])
const levels = ref([1, 2, 3, 4, 5])
const datalist = ref<any>({})

// 解析described字段，根据当前语言显示对应内容
const parsedDesc = computed(() => {
  if (!datalist.value?.described) {
    return null
  }
  console.log(datalist.value.described, 'JOAIJDAIDIWA')
  try {
    const parsed = JSON.parse(datalist.value.described)
    console.log(parsed, '解析')

    // 获取当前语言
    const currentLocale = locale.value || 'en'
    console.log('当前语言:', currentLocale)

    // 根据当前语言选择对应的内容
    if (parsed[currentLocale]) {
      // 如果当前语言存在，返回对应内容
      return {
        desc: parsed[currentLocale].desc,
        img: parsed[currentLocale].img
      }
    } else if (parsed.pt) {
      // 如果后端传的是pt，使用pt的内容
      return {
        desc: parsed.pt.desc,
        img: parsed.pt.img
      }
    } else {
      // 如果当前语言不存在，返回英文内容作为默认
      return {
        desc: parsed.en?.desc,
        img: parsed.en?.img
      }
    }
  } catch (error) {
    console.error('解析described字段失败:', error)
    return null
  }
})

// 获取条件值
function getConditionValue(level: number, type: number) {
  const info = promoterLevelInfo.value.find((item: any) => item.level === level)
  if (!info) return '-'

  // type: 3 表示邀请人数 (promoterNum)
  if (type === 3) {
    return info.promoterNum || '-'
  }
  // type: 5 表示投注金额 (bet)
  if (type === 5) {
    return info.bet ? formatBetAmount(info.bet) : '-'
  }

  return '-'
}

// 格式化投注金额显示
function formatBetAmount(amount: number) {
  return amount.toString()
}

// 动态调整表格字体大小 - 确保内容完整显示
const adjustTableFontSize = () => {
  const cells = document.querySelectorAll('.th, .td')
  cells.forEach(cell => {
    const element = cell as HTMLElement
    const text = element.textContent || ''

    // 根据文本长度调整字体大小，确保内容完整显示
    if (text.length > 10) {
      element.style.fontSize = '10px' // 增大字体
    } else if (text.length > 8) {
      element.style.fontSize = '11px' // 增大字体
    } else if (text.length > 6) {
      element.style.fontSize = '12px' // 增大字体
    } else {
      element.style.fontSize = '13px' // 增大字体
    }

    // 如果内容仍然溢出，进一步缩小字体
    if (element.scrollWidth > element.clientWidth) {
      element.style.fontSize = '9px' // 增大最小字体
    }

    // 确保最小字体可读性
    if (parseInt(element.style.fontSize) < 9) {
      element.style.fontSize = '9px' // 提高最小字体限制
    }
  })
}

// 窗口大小变化时重新调整字体
const handleResize = () => {
  adjustTableFontSize()
}

onMounted(async () => {
  try {
    const res = await getPromoterConfig()
    datalist.value = res.data
    console.log(datalist.value, 'datalist')
    if (res.data && res.data.promoterLevelInfo) {
      promoterLevelInfo.value = res.data.promoterLevelInfo

      // 数据加载完成后调整字体大小
      setTimeout(() => {
        adjustTableFontSize()
      }, 100)
    }

    // 监听窗口大小变化
    window.addEventListener('resize', handleResize)
  } catch (error) {
    console.error('获取推广员配置失败:', error)
  }
})

onUnmounted(() => {
  // 清理事件监听器
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
.promoter-table {
  border: 1px solid #009F76;
  border-radius: 8px;
  overflow: hidden;
  margin: 0 auto;
  width: 98%;
  background: transparent;
}

.table-header,
.table-row {
  display: flex;
  width: 100%;
}

.table-header {
  background: #006849;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
}

.th,
.td {
  flex: 1;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 40px;
  padding: 0 2px;
  /* 缩小左右间距 */
  /* line-height: 40px; */
  border-right: 1px solid #009F76;
  border-bottom: 1px solid #009F76;
  min-width: 0;
  /* 防止flex项目溢出 */
  box-sizing: border-box;
  /* 确保边框包含在宽度内 */
  /* overflow: visible; */
  /* 允许内容显示 */
  white-space: wrap;
  /* 不换行 */
  font-size: 9px;
  line-height: 13px;
  /* 增大默认字体大小 */
}

/* 当内容过长时，自动缩小字体 */
.th:has-text-overflow,
.td:has-text-overflow {
  font-size: 10px;
}

/* 更精确的字体大小控制 - 根据内容长度动态调整 */
.th,
.td {
  transition: font-size 0.2s ease;
}

/* 针对不同屏幕尺寸的响应式字体 - 确保内容完整显示 */
@media (max-width: 375px) {

  .th,
  .td {
    font-size: 11px;
    /* 增大字体 */
    padding: 0 1px;
    /* 进一步缩小间距 */
    height: 35px;
    line-height: 35px;
  }
}

@media (max-width: 320px) {

  .th,
  .td {
    font-size: 10px;
    /* 增大字体 */
    padding: 0 1px;
    height: 32px;
    line-height: 32px;
  }
}

/* 超小屏幕进一步优化 */
@media (max-width: 280px) {

  .th,
  .td {
    font-size: 9px;
    /* 增大字体 */
    padding: 0 1px;
    height: 30px;
    line-height: 30px;
  }
}

.th:last-child,
.td:last-child {
  border-right: none;
}

.table-row {
  background: #02523d;
  color: #fff;
  font-size: 12px;
}

.table-row:nth-child(even) {
  background: #176343;
  /* 斑马线效果 */
}

.table-row:last-child .td {
  border-bottom: none;
  /* 最后一行去掉下边框 */
}

/* 确保第一列有左边框 */
.th:first-child,
.td:first-child {
  border-left: 1px solid #009F76;
}

/* 确保表头有上边框 */
.table-header .th {
  border-top: 1px solid #009F76;
}

/* 强制所有行使用相同的flex布局 */
.table-header,
.table-row {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}
</style>
